var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaslCalisir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5390"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 305",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M25 18L14.5 24.0622L14.5 11.9378L25 18Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaslCalisir);
export default __webpack_public_path__ + "static/media/nasılCalisir.120737e77f92aca5e0846bf151ccd175.svg";
export { ForwardRef as ReactComponent };